import React from "react";
import * as styles from "./FormattedRichText.module.css";
import { KontentRichText, ComponentProps } from "../../../types/index";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import DivWrapper from "../../containers/DivWrapper";
import { FormattedRichTextWidth } from ".";

interface Props extends ComponentProps {
  width: FormattedRichTextWidth;
  content: KontentRichText;
  fontSize: string | undefined;
  textAlignment: "left" | "center" | "right";
  margin: {
    top: string;
    bottom: string;
    left: string;
    right: string;
  };
  padding: {
    top: string;
    bottom: string;
    left: string;
    right: string;
  };
}

export const FormattedRichText: React.FC<Props> = ({
  content,
  fontSize,
  margin,
  padding,
  textAlignment,
  width,
  ...props
}) => {
  let classes = `${styles.formattedRichText} `;

  if (fontSize) {
    classes += `font-size-${fontSize} `;
  }

  if (margin?.top) {
    classes += `margin-top--${margin.top} `;
  }

  if (margin?.bottom) {
    classes += `margin-bottom--${margin.bottom} `;
  }

  if (margin?.left) {
    classes += `margin-left--${margin.left} `;
  }

  if (margin?.right) {
    classes += `margin-right--${margin.right} `;
  }

  if (padding?.top) {
    classes += `padding-top--${padding.top} `;
  }

  if (padding?.bottom) {
    classes += `padding-bottom--${padding.bottom} `;
  }

  if (padding?.left) {
    classes += `padding-left--${padding.left} `;
  }

  if (padding?.right) {
    classes += `padding-right--${padding.right} `;
  }

  if (width === "contained") {
    classes += `contained-component `;
  }

  if (width === "half_width") {
    classes += `${styles.halfWidth} `;
  }

  if (textAlignment === "center") {
    classes += ` ${styles.alignCenter}`;
  }

  if (textAlignment === "right") {
    classes += ` ${styles.alignRight}`;
  }

  return (
    <DivWrapper {...props}>
      <CustomRichTextElement content={content} classes={classes} />
    </DivWrapper>
  );
};
